"use client"
import React, { useState, useEffect, useRef } from 'react';


import DataTableGenerica from '../components/DataTableGenerica/DataTableGenerica';
import DiseñadorFormulario from '../components/DataTableGenerica/DiseñadorFormulario';
import FormularioStep from '../components/DataTableGenerica/FormularioStep';

import { Button } from 'primereact/button';

import { GenericaSistemaService } from '../service/GenericaSistemaService';

import AuthStorage from '../storage/AuthStorage'
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import lodash from "lodash";

import AuthController from '../controller/AuthController';
import { getConfigSubdomainDefault, GetCurrentUserDefault } from '../storage/getConfigSubdomainDefault';

import Reporte from './Reporte';
import Reporte2 from './Reporte2';
import ReporteGraficos from './ReporteGraficos';

import ReportePowerBi from './ReportePowerBi';
import DynamicQR from './DynamicQR';




const ContentCardOrganizator = (props) => {

    const _ = lodash;

    const _CARD_TOP = "CARD_TOP";
    const _CARD_02 = "CARD_TWO";
    const _CARD_03 = "CARD_THREE";
    const _CARD_04 = "CARD_FOUR";

    const _CARD_05 = "CARD_05";
    const _CARD_06 = "CARD_06";
    const _CARD_07 = "CARD_07";
    const _CARD_08 = "CARD_08";
    const _CARD_09 = "CARD_09";
    const _CARD_10 = "CARD_10";

    const _TIPO_OPERACION_VIEW = "VIEW";
    const _TIPO_OPERACION_ASSING = "ASIGN";
    const _TIPO_OPERACION_QUITAR_ASIG = "QUITAR_ASIG";

    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);
    const [selectedTipoGenericaCard02, setSelectedTipoGenericaCard02] = useState(undefined);
    const [selectedTipoGenericaCard03, setSelectedTipoGenericaCard03] = useState(undefined);
    const [selectedTipoGenericaCard04, setSelectedTipoGenericaCard04] = useState(undefined);
    const [selectedTipoGenericaCard05, setSelectedTipoGenericaCard05] = useState(undefined);
    const [selectedTipoGenericaCard06, setSelectedTipoGenericaCard06] = useState(undefined);
    const [selectedTipoGenericaCard07, setSelectedTipoGenericaCard07] = useState(undefined);
    const [selectedTipoGenericaCard08, setSelectedTipoGenericaCard08] = useState(undefined);
    const [selectedTipoGenericaCard09, setSelectedTipoGenericaCard09] = useState(undefined);
    const [selectedTipoGenericaCard10, setSelectedTipoGenericaCard10] = useState(undefined);

    const [selectedItemCard02, setSelectedItemCard02] = useState(undefined);
    const [selectedItemCard03, setSelectedItemCard03] = useState(undefined);
    const [selectedItemCard04, setSelectedItemCard04] = useState(undefined);
    const [selectedItemCard05, setSelectedItemCard05] = useState(undefined);
    const [selectedItemCard06, setSelectedItemCard06] = useState(undefined);
    const [selectedItemCard07, setSelectedItemCard07] = useState(undefined);
    const [selectedItemCard08, setSelectedItemCard08] = useState(undefined);
    const [selectedItemCard09, setSelectedItemCard09] = useState(undefined);
    const [selectedItemCard10, setSelectedItemCard10] = useState(undefined);

    const authController = new AuthController();
    const [authStorage, setAuthStorage] = useState(undefined);

    const [dataConfigSubdomain, setDataConfigSubdomain] = useState(getConfigSubdomainDefault);
    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoLogin } = dataConfigSubdomain;



    const userDetails = authStorage ? authStorage.GetCurrentUser() : GetCurrentUserDefault();
    let { userName, idEmpresa, idioma, sessionGUID, documentoInvitado } = userDetails;


    const genericaSistemaService = new GenericaSistemaService();

    const toast = useRef(null);

    // hook to check the app version on route change
    function useVersionCheck() {
        // check if a version update (refresh) needed on route change

        console.log("Configura validación versión")

        if (typeof window !== undefined && authStorage!== undefined) {

            let location = window.location;
            React.useLayoutEffect(() => {
                console.log("verifica versión")
                // if there is an update available and no state passed to route
                if (!location.state && authStorage.getVersionUpdateNeeded()) {
                    authStorage.removeVersionUpdateNeeded();  // remove the storage object
                    window.location.reload(); // refresh the browser
                }
            }, [location]);

        }

    };

    useEffect(() => {

        const authStorage = new AuthStorage(window.location.pathname);
        let mewdataConfigSubdomain = authStorage.getConfigSubdomain();

        subdomain = mewdataConfigSubdomain.subdomain;
        idSuscripcion = mewdataConfigSubdomain.idSuscripcion;
        idEmpresaInit = mewdataConfigSubdomain.idEmpresaInit;
        idiomaInit = mewdataConfigSubdomain.idiomaInit;

        setAuthStorage(authStorage);
        setDataConfigSubdomain(mewdataConfigSubdomain);

        const userDetails = authStorage.GetCurrentUser();
        userName = userDetails.userName;
        idioma = userDetails.idioma;
        idEmpresa = userDetails.idEmpresa;
        sessionGUID = userDetails.sessionGUID
        documentoInvitado = userDetails.documentoInvitado

        useVersionCheck();
        

    }, []);


    useEffect(() => {

        console.log("hola11212");

        if (props.selectedTipoGenerica === undefined) {
            console.log("Cargue inicial");
        }
        else if ((props.selectedTipoGenerica !== undefined && selectedTipoGenerica === undefined)) {
            setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
        }
        else if (props.selectedTipoGenerica !== undefined && props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg) {
            setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
        }
        else {

            let newSelectedTipoGenerica = undefined;

            if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
                //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
                newSelectedTipoGenerica = {
                    ...selectedTipoGenerica, version: props.selectedTipoGenerica.version,
                    filtroUts: { ...props.selectedTipoGenerica.filtroUts },
                    variableRestriccionExterna: { ...props.variableRestriccionExterna }
                };

                setSelectedTipoGenerica(newSelectedTipoGenerica);
                setSelectedItemCard02(undefined);
                setSelectedItemCard03(undefined);
                setSelectedItemCard04(undefined);
                setSelectedItemCard05(undefined);
                setSelectedItemCard06(undefined);
                setSelectedItemCard07(undefined);
                setSelectedItemCard08(undefined);
                setSelectedItemCard09(undefined);
                setSelectedItemCard10(undefined);
            }
            else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {

                let newSelectedTipoGenerica2 = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
                setSelectedTipoGenerica(newSelectedTipoGenerica2);
            }

        }

    }, [props.selectedTipoGenerica]);


    useEffect(() => {

        if (selectedTipoGenerica !== undefined && selectedTipoGenerica.operaciones === undefined) {
            genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                let newSelectedTipoGenerica = data.data;

                if (selectedTipoGenerica.filtroUts !== undefined) {
                    newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                    newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                }

                if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                    newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
                }
                else {
                    newSelectedTipoGenerica.variableRestriccionExterna = {};
                }

                if (!_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                    newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
                }
                if (selectedTipoGenerica.version !== undefined) {
                    newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                }

                console.log("GetTipoGenericaSistemaByTg - Organizador", newSelectedTipoGenerica);

                setSelectedTipoGenerica(newSelectedTipoGenerica);

            });

        }
        else if (selectedTipoGenerica !== undefined) {
            cargarDatos();
        }

    }, [selectedTipoGenerica]);

    const cargarDatos = () => {

        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 1) {

            let tgConOperacionesOfTg = [];

            genericaSistemaService.GetAllTipoGenericaConOperacionesOfTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                tgConOperacionesOfTg = [...data.data]

                let filtroUts = {};
                let variableRestriccionExterna = {};
                let itemOpsCampo = {};


                let newSelectedTipoGenerica_seccion_CARD_02 = undefined;
                let newSelectedTipoGenerica_seccion_CARD_03 = undefined;
                let newSelectedTipoGenerica_seccion_CARD_04 = undefined;
                let newSelectedTipoGenerica_seccion_CARD_05 = undefined;
                let newSelectedTipoGenerica_seccion_CARD_06 = undefined;
                let newSelectedTipoGenerica_seccion_CARD_07 = undefined;
                let newSelectedTipoGenerica_seccion_CARD_08 = undefined;
                let newSelectedTipoGenerica_seccion_CARD_09 = undefined;
                let newSelectedTipoGenerica_seccion_CARD_10 = undefined;

                if (tgConOperacionesOfTg.length > 0) {

                    let operaciontgRefCard02 = undefined;

                    for (let i = 0; i < tgConOperacionesOfTg.length; i++) {
                        operaciontgRefCard02 = tgConOperacionesOfTg[i];
                        if (operaciontgRefCard02.seccion === _CARD_02)
                            break;
                    }

                    if (operaciontgRefCard02 !== undefined) {


                        filtroUts = {};
                        variableRestriccionExterna = {};
                        itemOpsCampo = {};

                        for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                            itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                            if (itemOpsCampo.id === operaciontgRefCard02.id) {
                                filtroUts[itemOpsCampo.campotgRef] = "";

                                if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                    variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: "" };
                                }

                            }
                        }

                        newSelectedTipoGenerica_seccion_CARD_02 = {
                            ...operaciontgRefCard02.tgRefConfig,
                            version: 1,
                            //tg: tgRefCard02.tgRefConfig.tgRef,
                            cti: operaciontgRefCard02.ctitgRef,
                            ctiTexto: operaciontgRefCard02.ctiTextotgRef,
                            //orden: tgRefCard02.tgRefConfig.ordentgRef,
                            //cgCampo: tgRefCard02.tgRefConfig.cgCampotgRef,
                            //operaciones: tgRefCard02.tgRefConfig.operaciones,
                            //operacionesCampos: tgRefCard02.tgRefConfig.operacionesCampos,
                            filtroUts: { ...filtroUts },
                            variableRestriccionExterna: { ...variableRestriccionExterna },
                            ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")
                        }

                    }

                    //   para CARD 03  ************************************
                    if (selectedTipoGenerica.cantidadCard >= 3) {


                        let operaciontgRefCard03 = {};

                        for (let i = 0; i < tgConOperacionesOfTg.length; i++) {
                            operaciontgRefCard03 = tgConOperacionesOfTg[i];
                            if (operaciontgRefCard03.seccion === _CARD_03)
                                break;
                        }

                        if (operaciontgRefCard03 !== undefined) {

                            filtroUts = {};
                            variableRestriccionExterna = {};
                            itemOpsCampo = {};

                            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                                if (itemOpsCampo.id === operaciontgRefCard03.id) {
                                    filtroUts[itemOpsCampo.campotgRef] = "";
                                    if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: "" };
                                    }
                                }
                            }

                            newSelectedTipoGenerica_seccion_CARD_03 = {
                                ...operaciontgRefCard03.tgRefConfig,
                                version: 1,
                                //tg: operaciontgRefCard03.tgRefConfig.tgRef,
                                cti: operaciontgRefCard03.ctitgRef,
                                ctiTexto: operaciontgRefCard03.ctiTextotgRef,
                                //orden: operaciontgRefCard03.ordentgRef,
                                //cgCampo: operaciontgRefCard03.tgRefConfig.cgCampotgRef,
                                //operaciones: operaciontgRefCard03.tgRefConfig.operaciones,
                                //operacionesCampos: operaciontgRefCard03.tgRefConfig.operacionesCampos,
                                filtroUts: { ...filtroUts },
                                variableRestriccionExterna: { ...variableRestriccionExterna },
                                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")

                            }

                        }
                    }


                    //   para CARD 04  ************************************

                    if (selectedTipoGenerica.cantidadCard >= 4) {


                        let operaciontgRefCard04 = {};

                        for (let i = 0; i < tgConOperacionesOfTg.length; i++) {
                            operaciontgRefCard04 = tgConOperacionesOfTg[i];
                            if (operaciontgRefCard04.seccion === _CARD_04)
                                break;
                        }

                        if (operaciontgRefCard04 !== undefined) {

                            filtroUts = {};
                            variableRestriccionExterna = {}
                            itemOpsCampo = {};

                            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                                if (itemOpsCampo.id === operaciontgRefCard04.id) {
                                    filtroUts[itemOpsCampo.campotgRef] = "";
                                    if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: "" };
                                    }

                                }
                            }

                            newSelectedTipoGenerica_seccion_CARD_04 = {
                                ...operaciontgRefCard04.tgRefConfig,
                                version: 1,
                                //tg: operaciontgRefCard04.tgRefConfig.tgRef,
                                cti: operaciontgRefCard04.ctitgRef,
                                ctiTexto: operaciontgRefCard04.ctiTextotgRef,
                                //orden: operaciontgRefCard04.ordentgRef,
                                //cgCampo: operaciontgRefCard04.tgRefConfig.cgCampotgRef,
                                //operaciones: operaciontgRefCard04.tgRefConfig.operaciones,
                                //operacionesCampos: operaciontgRefCard04.tgRefConfig.operacionesCampos,
                                filtroUts: { ...filtroUts },
                                variableRestriccionExterna: { ...variableRestriccionExterna },
                                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")

                            }

                        }
                    }

                    //   para CARD 05  ************************************

                    if (selectedTipoGenerica.cantidadCard >= 5) {


                        let operaciontgRefCard05 = {};

                        for (let i = 0; i < tgConOperacionesOfTg.length; i++) {
                            operaciontgRefCard05 = tgConOperacionesOfTg[i];
                            if (operaciontgRefCard05.seccion === _CARD_05)
                                break;
                        }

                        if (operaciontgRefCard05 !== undefined) {

                            filtroUts = {};
                            variableRestriccionExterna = {};
                            itemOpsCampo = {};

                            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                                if (itemOpsCampo.id === operaciontgRefCard05.id) {
                                    filtroUts[itemOpsCampo.campotgRef] = "";
                                    if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: "" };
                                    }
                                }
                            }

                            newSelectedTipoGenerica_seccion_CARD_05 = {
                                ...operaciontgRefCard05.tgRefConfig,
                                version: 1,
                                //tg: operaciontgRefCard05.tgRefConfig.tgRef,
                                cti: operaciontgRefCard05.ctitgRef,
                                ctiTexto: operaciontgRefCard05.ctiTextotgRef,
                                //orden: operaciontgRefCard05.ordentgRef,
                                //cgCampo: operaciontgRefCard05.tgRefConfig.cgCampotgRef,
                                //operaciones: operaciontgRefCard05.tgRefConfig.operaciones,
                                //operacionesCampos: operaciontgRefCard05.tgRefConfig.operacionesCampos,
                                filtroUts: { ...filtroUts },
                                variableRestriccionExterna: { ...variableRestriccionExterna },
                                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")

                            }

                        }

                    }

                    //   para CARD 06  ************************************

                    if (selectedTipoGenerica.cantidadCard >= 6) {


                        let operaciontgRefCard06 = {};

                        for (let i = 0; i < tgConOperacionesOfTg.length; i++) {
                            operaciontgRefCard06 = tgConOperacionesOfTg[i];
                            if (operaciontgRefCard06.seccion === _CARD_06)
                                break;
                        }

                        if (operaciontgRefCard06 !== undefined) {

                            filtroUts = {};
                            variableRestriccionExterna = {};
                            itemOpsCampo = {};

                            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                                if (itemOpsCampo.id === operaciontgRefCard06.id) {
                                    filtroUts[itemOpsCampo.campotgRef] = "";
                                    if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: "" };
                                    }
                                }
                            }

                            newSelectedTipoGenerica_seccion_CARD_06 = {
                                ...operaciontgRefCard06.tgRefConfig,
                                version: 1,
                                //tg: operaciontgRefCard06.tgRefConfig.tgRef,
                                cti: operaciontgRefCard06.ctitgRef,
                                ctiTexto: operaciontgRefCard06.ctiTextotgRef,
                                //orden: operaciontgRefCard06.ordentgRef,
                                //cgCampo: operaciontgRefCard06.tgRefConfig.cgCampotgRef,
                                //operaciones: operaciontgRefCard06.tgRefConfig.operaciones,
                                //operacionesCampos: operaciontgRefCard06.tgRefConfig.operacionesCampos,
                                filtroUts: { ...filtroUts },
                                variableRestriccionExterna: { ...variableRestriccionExterna },
                                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")

                            }

                        }

                    }

                    //   para CARD 07  ************************************

                    if (selectedTipoGenerica.cantidadCard >= 7) {


                        let operaciontgRefCard07 = {};

                        for (let i = 0; i < tgConOperacionesOfTg.length; i++) {
                            operaciontgRefCard07 = tgConOperacionesOfTg[i];
                            if (operaciontgRefCard07.seccion === _CARD_07)
                                break;
                        }

                        if (operaciontgRefCard07 !== undefined) {

                            filtroUts = {};
                            variableRestriccionExterna = {};
                            itemOpsCampo = {};

                            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                                if (itemOpsCampo.id === operaciontgRefCard07.id) {
                                    filtroUts[itemOpsCampo.campotgRef] = "";
                                    if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: "" };
                                    }
                                }
                            }

                            newSelectedTipoGenerica_seccion_CARD_07 = {
                                ...operaciontgRefCard07.tgRefConfig,
                                version: 1,
                                //tg: operaciontgRefCard07.tgRefConfig.tgRef,
                                cti: operaciontgRefCard07.ctitgRef,
                                ctiTexto: operaciontgRefCard07.ctiTextotgRef,
                                //orden: operaciontgRefCard07.ordentgRef,
                                //cgCampo: operaciontgRefCard07.tgRefConfig.cgCampotgRef,
                                //operaciones: operaciontgRefCard07.tgRefConfig.operaciones,
                                //operacionesCampos: operaciontgRefCard07.tgRefConfig.operacionesCampos,
                                filtroUts: { ...filtroUts },
                                variableRestriccionExterna: { ...variableRestriccionExterna },
                                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")

                            }

                        }

                    }

                    //   para CARD 08  ************************************

                    if (selectedTipoGenerica.cantidadCard >= 8) {


                        let operaciontgRefCard08 = {};

                        for (let i = 0; i < tgConOperacionesOfTg.length; i++) {
                            operaciontgRefCard08 = tgConOperacionesOfTg[i];
                            if (operaciontgRefCard08.seccion === _CARD_08)
                                break;
                        }

                        if (operaciontgRefCard08 !== undefined) {

                            filtroUts = {};
                            variableRestriccionExterna = {};
                            itemOpsCampo = {};

                            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                                if (itemOpsCampo.id === operaciontgRefCard08.id) {
                                    filtroUts[itemOpsCampo.campotgRef] = "";
                                    if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: "" };
                                    }
                                }
                            }

                            newSelectedTipoGenerica_seccion_CARD_08 = {
                                ...operaciontgRefCard08.tgRefConfig,
                                version: 1,
                                //tg: operaciontgRefCard08.tgRefConfig.tgRef,
                                cti: operaciontgRefCard08.ctitgRef,
                                ctiTexto: operaciontgRefCard08.ctiTextotgRef,
                                //orden: operaciontgRefCard08.ordentgRef,
                                //cgCampo: operaciontgRefCard08.tgRefConfig.cgCampotgRef,
                                //operaciones: operaciontgRefCard08.tgRefConfig.operaciones,
                                //operacionesCampos: operaciontgRefCard08.tgRefConfig.operacionesCampos,
                                filtroUts: { ...filtroUts },
                                variableRestriccionExterna: { ...variableRestriccionExterna },
                                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")

                            }

                        }

                    }

                    //   para CARD 09  ************************************

                    if (selectedTipoGenerica.cantidadCard >= 9) {


                        let operaciontgRefCard09 = {};

                        for (let i = 0; i < tgConOperacionesOfTg.length; i++) {
                            operaciontgRefCard09 = tgConOperacionesOfTg[i];
                            if (operaciontgRefCard09.seccion === _CARD_09)
                                break;
                        }

                        if (operaciontgRefCard09 !== undefined) {

                            filtroUts = {};
                            variableRestriccionExterna = {};
                            itemOpsCampo = {};

                            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                                if (itemOpsCampo.id === operaciontgRefCard09.id) {
                                    filtroUts[itemOpsCampo.campotgRef] = "";
                                    if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: "" };
                                    }
                                }
                            }

                            newSelectedTipoGenerica_seccion_CARD_09 = {
                                ...operaciontgRefCard09.tgRefConfig,
                                version: 1,
                                //tg: operaciontgRefCard09.tgRefConfig.tgRef,
                                cti: operaciontgRefCard09.ctitgRef,
                                ctiTexto: operaciontgRefCard09.ctiTextotgRef,
                                //orden: operaciontgRefCard09.ordentgRef,
                                //cgCampo: operaciontgRefCard09.tgRefConfig.cgCampotgRef,
                                //operaciones: operaciontgRefCard09.tgRefConfig.operaciones,
                                //operacionesCampos: operaciontgRefCard09.tgRefConfig.operacionesCampos,
                                filtroUts: { ...filtroUts },
                                variableRestriccionExterna: { ...variableRestriccionExterna },
                                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")

                            }

                        }

                    }

                    //   para CARD 10  ************************************

                    if (selectedTipoGenerica.cantidadCard >= 10) {


                        let operaciontgRefCard10 = {};

                        for (let i = 0; i < tgConOperacionesOfTg.length; i++) {
                            operaciontgRefCard10 = tgConOperacionesOfTg[i];
                            if (operaciontgRefCard10.seccion === _CARD_10)
                                break;
                        }

                        if (operaciontgRefCard10 !== undefined) {

                            filtroUts = {};
                            variableRestriccionExterna = {};
                            itemOpsCampo = {};

                            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                                if (itemOpsCampo.id === operaciontgRefCard10.id) {
                                    filtroUts[itemOpsCampo.campotgRef] = "";
                                    if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: "" };
                                    }
                                }
                            }

                            newSelectedTipoGenerica_seccion_CARD_10 = {
                                ...operaciontgRefCard10.tgRefConfig,
                                version: 1,
                                //tg: operaciontgRefCard10.tgRefConfig.tgRef,
                                cti: operaciontgRefCard10.ctitgRef,
                                ctiTexto: operaciontgRefCard10.ctiTextotgRef,
                                //orden: operaciontgRefCard10.ordentgRef,
                                //cgCampo: operaciontgRefCard10.tgRefConfig.cgCampotgRef,
                                //operaciones: operaciontgRefCard10.tgRefConfig.operaciones,
                                //operacionesCampos: operaciontgRefCard10.tgRefConfig.operacionesCampos,
                                filtroUts: { ...filtroUts },
                                variableRestriccionExterna: { ...variableRestriccionExterna },
                                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")

                            }

                        }

                    }


                    setSelectedTipoGenericaCard02(newSelectedTipoGenerica_seccion_CARD_02);
                    setSelectedTipoGenericaCard03(newSelectedTipoGenerica_seccion_CARD_03);
                    setSelectedTipoGenericaCard04(newSelectedTipoGenerica_seccion_CARD_04);

                    setSelectedTipoGenericaCard05(newSelectedTipoGenerica_seccion_CARD_05);
                    setSelectedTipoGenericaCard06(newSelectedTipoGenerica_seccion_CARD_06);
                    setSelectedTipoGenericaCard07(newSelectedTipoGenerica_seccion_CARD_07);
                    setSelectedTipoGenericaCard08(newSelectedTipoGenerica_seccion_CARD_08);
                    setSelectedTipoGenericaCard09(newSelectedTipoGenerica_seccion_CARD_09);
                    setSelectedTipoGenericaCard10(newSelectedTipoGenerica_seccion_CARD_10);

                }
                else {
                    console.log("no hay operaciones asociadas a TG");
                }

            });

        }

    }

    const onSelectionChangeCardTop = (newVal) => {

        let filtroUts = {};
        let variableRestriccionExterna = {};
        let itemOpsCampo = {}


        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 1) {

            if (selectedTipoGenericaCard02 != undefined) {

                let newselectedTipoGenericaCard02 = { ...selectedTipoGenericaCard02 }
                let operaciontgRefCard02 = undefined;


                let itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard02 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard02.seccion === _CARD_02 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard02.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";

                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };

                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }

                        }
                    }

                    newselectedTipoGenericaCard02.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard02.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard02(undefined);
                    setSelectedTipoGenericaCard02(newselectedTipoGenericaCard02);
                    //console.log("newselectedTipoGenericaCard02, ", newselectedTipoGenericaCard02);
                }

            }

            if (selectedTipoGenericaCard03 != undefined) {

                // para card 03
                let newselectedTipoGenericaCard03 = { ...selectedTipoGenericaCard03 }

                let operaciontgRefCard03 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};

                let encontrado = false;


                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard03 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard03.seccion === _CARD_03 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }
                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard03.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }



                        }
                    }

                    newselectedTipoGenericaCard03.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard03.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard03(undefined);
                    setSelectedTipoGenericaCard03(newselectedTipoGenericaCard03);

                    //console.log("newselectedTipoGenericaCard03, ", newselectedTipoGenericaCard03);

                }

            }

            // para card 04

            if (selectedTipoGenericaCard04 != undefined) {

                let newselectedTipoGenericaCard04 = { ...selectedTipoGenericaCard04 }

                let operaciontgRefCard04 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard04 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard04.seccion === _CARD_04 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard04.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard04.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard04.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard04(undefined);
                    setSelectedTipoGenericaCard04(newselectedTipoGenericaCard04);
                    //console.log("newselectedTipoGenericaCard04, ", newselectedTipoGenericaCard04);

                }

            }

            // para card 05

            if (selectedTipoGenericaCard05 != undefined) {

                let newselectedTipoGenericaCard05 = { ...selectedTipoGenericaCard05 }

                let operaciontgRefCard05 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard05 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard05.seccion === _CARD_05 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard05.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard05.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard05.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard05(undefined);
                    setSelectedTipoGenericaCard05(newselectedTipoGenericaCard05);
                    //console.log("newselectedTipoGenericaCard05, ", newselectedTipoGenericaCard05);

                }

            }


            // para card 06

            if (selectedTipoGenericaCard06 != undefined) {

                let newselectedTipoGenericaCard06 = { ...selectedTipoGenericaCard06 }

                let operaciontgRefCard06 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard06 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard06.seccion === _CARD_06 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard06.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard06.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard06.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard06(undefined);
                    setSelectedTipoGenericaCard06(newselectedTipoGenericaCard06);
                    //console.log("newselectedTipoGenericaCard06, ", newselectedTipoGenericaCard06);

                }

            }

            // para card 07

            if (selectedTipoGenericaCard07 != undefined) {

                let newselectedTipoGenericaCard07 = { ...selectedTipoGenericaCard07 }

                let operaciontgRefCard07 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard07 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard07.seccion === _CARD_07 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard07.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard07.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard07.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard07(undefined);
                    setSelectedTipoGenericaCard07(newselectedTipoGenericaCard07);
                    //console.log("newselectedTipoGenericaCard07, ", newselectedTipoGenericaCard07);

                }

            }

            // para card 08

            if (selectedTipoGenericaCard08 != undefined) {

                let newselectedTipoGenericaCard08 = { ...selectedTipoGenericaCard08 }

                let operaciontgRefCard08 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard08 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard08.seccion === _CARD_08 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard08.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard08.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard08.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard08(undefined);
                    setSelectedTipoGenericaCard08(newselectedTipoGenericaCard08);
                    //console.log("newselectedTipoGenericaCard08, ", newselectedTipoGenericaCard08);

                }

            }

            // para card 09

            if (selectedTipoGenericaCard09 != undefined) {

                let newselectedTipoGenericaCard09 = { ...selectedTipoGenericaCard09 }

                let operaciontgRefCard09 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard09 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard09.seccion === _CARD_09 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard09.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard09.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard09.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard09(undefined);
                    setSelectedTipoGenericaCard09(newselectedTipoGenericaCard09);
                    //console.log("newselectedTipoGenericaCard09, ", newselectedTipoGenericaCard09);

                }

            }

            // para card 10

            if (selectedTipoGenericaCard10 != undefined) {

                let newselectedTipoGenericaCard10 = { ...selectedTipoGenericaCard10 }

                let operaciontgRefCard10 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard10 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard10.seccion === _CARD_10 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard10.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard10.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard10.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard10(undefined);
                    setSelectedTipoGenericaCard10(newselectedTipoGenericaCard10);
                    //console.log("newselectedTipoGenericaCard10, ", newselectedTipoGenericaCard10);

                }

            }


        }


    }

    const onSelectionChangeCard02 = (newVal) => {

        setSelectedItemCard02({ ...newVal });

        let filtroUts = {};
        let variableRestriccionExterna = {};
        let itemOpsCampo = {};

        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 2) {



            // para card 03
            if (selectedTipoGenericaCard03 != undefined) {


                let newselectedTipoGenericaCard03 = { ...selectedTipoGenericaCard03 }

                let operaciontgRefCard03 = {};

                let itemOpsCampo = { ...operaciontgRefCard03 }
                let encontrado = false;


                for (let i = 0; i < selectedTipoGenericaCard02.operaciones.length; i++) {
                    operaciontgRefCard03 = selectedTipoGenericaCard02.operaciones[i];
                    if (operaciontgRefCard03.seccion === _CARD_03 && selectedTipoGenericaCard02.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard02.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard02.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard03.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';

                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }

                        }
                    }

                    newselectedTipoGenericaCard03.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard03.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard03(undefined);
                    setSelectedTipoGenericaCard03(newselectedTipoGenericaCard03);

                    //console.log("newselectedTipoGenericaCard03, ", newselectedTipoGenericaCard03);
                }

            }

            // para card 04

            if (selectedTipoGenericaCard04 != undefined) {

                let newselectedTipoGenericaCard04 = { ...selectedTipoGenericaCard04 }

                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};

                let operaciontgRefCard04 = {};

                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard02.operaciones.length; i++) {
                    operaciontgRefCard04 = selectedTipoGenericaCard02.operaciones[i];
                    if (operaciontgRefCard04.seccion === _CARD_04 && selectedTipoGenericaCard02.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard02.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard02.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard04.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';

                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }

                        }
                    }

                    newselectedTipoGenericaCard04.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard04.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard04(undefined);
                    setSelectedTipoGenericaCard04(newselectedTipoGenericaCard04);
                    //console.log("newselectedTipoGenericaCard04, ", newselectedTipoGenericaCard04);

                }


            }

            // para card 05

            if (selectedTipoGenericaCard05 != undefined) {

                let newselectedTipoGenericaCard05 = { ...selectedTipoGenericaCard05 }

                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};

                let operaciontgRefCard05 = {};


                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard02.operaciones.length; i++) {
                    operaciontgRefCard05 = selectedTipoGenericaCard02.operaciones[i];
                    if (operaciontgRefCard05.seccion === _CARD_05 && selectedTipoGenericaCard02.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard02.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard02.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard05.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';

                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }

                        }
                    }

                    newselectedTipoGenericaCard05.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard05.variableRestriccionExterna = { ...variableRestriccionExterna };


                    setSelectedItemCard05(undefined);
                    setSelectedTipoGenericaCard05(newselectedTipoGenericaCard05);
                    //console.log("newselectedTipoGenericaCard05, ", newselectedTipoGenericaCard05);

                }


            }

            // para card 06

            if (selectedTipoGenericaCard06 != undefined) {

                let newselectedTipoGenericaCard06 = { ...selectedTipoGenericaCard06 }

                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};

                let operaciontgRefCard06 = {};


                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard02.operaciones.length; i++) {
                    operaciontgRefCard06 = selectedTipoGenericaCard02.operaciones[i];
                    if (operaciontgRefCard06.seccion === _CARD_06 && selectedTipoGenericaCard02.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard02.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard02.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard06.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';

                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }

                        }
                    }

                    newselectedTipoGenericaCard06.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard06.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard06(undefined);
                    setSelectedTipoGenericaCard06(newselectedTipoGenericaCard06);
                    //console.log("newselectedTipoGenericaCard06, ", newselectedTipoGenericaCard06);

                }


            }

            // para card 07

            if (selectedTipoGenericaCard07 != undefined) {

                let newselectedTipoGenericaCard07 = { ...selectedTipoGenericaCard07 }

                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};

                let operaciontgRefCard07 = {};


                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard02.operaciones.length; i++) {
                    operaciontgRefCard07 = selectedTipoGenericaCard02.operaciones[i];
                    if (operaciontgRefCard07.seccion === _CARD_07 && selectedTipoGenericaCard02.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard02.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard02.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard07.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';

                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }

                        }
                    }

                    newselectedTipoGenericaCard07.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard07.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard07(undefined);
                    setSelectedTipoGenericaCard07(newselectedTipoGenericaCard07);
                    //console.log("newselectedTipoGenericaCard07, ", newselectedTipoGenericaCard07);

                }


            }

            // para card 08

            if (selectedTipoGenericaCard08 != undefined) {

                let newselectedTipoGenericaCard08 = { ...selectedTipoGenericaCard08 }

                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};

                let operaciontgRefCard08 = {};


                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard02.operaciones.length; i++) {
                    operaciontgRefCard08 = selectedTipoGenericaCard02.operaciones[i];
                    if (operaciontgRefCard08.seccion === _CARD_08 && selectedTipoGenericaCard02.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard02.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard02.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard08.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';

                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }

                        }
                    }

                    newselectedTipoGenericaCard08.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard08.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard08(undefined);
                    setSelectedTipoGenericaCard08(newselectedTipoGenericaCard08);
                    //console.log("newselectedTipoGenericaCard08, ", newselectedTipoGenericaCard08);

                }


            }

            // para card 09

            if (selectedTipoGenericaCard09 != undefined) {

                let newselectedTipoGenericaCard09 = { ...selectedTipoGenericaCard09 }

                let operaciontgRefCard09 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard09 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard09.seccion === _CARD_09 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard09.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard09.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard09.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard09(undefined);
                    setSelectedTipoGenericaCard09(newselectedTipoGenericaCard09);
                    //console.log("newselectedTipoGenericaCard09, ", newselectedTipoGenericaCard09);

                }

            }

            // para card 10

            if (selectedTipoGenericaCard10 != undefined) {

                let newselectedTipoGenericaCard10 = { ...selectedTipoGenericaCard10 }

                let operaciontgRefCard10 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard10 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard10.seccion === _CARD_10 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard10.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard10.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard10.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard10(undefined);
                    setSelectedTipoGenericaCard10(newselectedTipoGenericaCard10);
                    //console.log("newselectedTipoGenericaCard10, ", newselectedTipoGenericaCard10);

                }

            }

        }

    }

    const onSelectionChangeCard03 = (newVal) => {

        setSelectedItemCard03({ ...newVal });

        let filtroUts = {};
        let variableRestriccionExterna = {};
        let itemOpsCampo = {}


        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 3) {

            // para card 04

            if (selectedTipoGenericaCard04 != undefined) {

                let newselectedTipoGenericaCard04 = { ...selectedTipoGenericaCard04 }

                let operaciontgRefCard04 = {};


                let itemOpsCampo = { ...operaciontgRefCard04 }
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard03.operaciones.length; i++) {
                    operaciontgRefCard04 = selectedTipoGenericaCard03.operaciones[i];
                    if (operaciontgRefCard04.seccion === _CARD_04 && selectedTipoGenericaCard03.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard03.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard03.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard04.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard04.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard04.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard04(undefined);
                    setSelectedTipoGenericaCard04(newselectedTipoGenericaCard04);
                    //console.log("newselectedTipoGenericaCard04, ", newselectedTipoGenericaCard04);

                }


            }

            // para card 05

            if (selectedTipoGenericaCard05 != undefined) {

                let newselectedTipoGenericaCard05 = { ...selectedTipoGenericaCard05 }

                let operaciontgRefCard05 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard03.operaciones.length; i++) {
                    operaciontgRefCard05 = selectedTipoGenericaCard03.operaciones[i];
                    if (operaciontgRefCard05.seccion === _CARD_05 && selectedTipoGenericaCard03.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard03.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard03.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard05.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard05.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard05.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard05(undefined);
                    setSelectedTipoGenericaCard05(newselectedTipoGenericaCard05);
                    //console.log("newselectedTipoGenericaCard05, ", newselectedTipoGenericaCard05);

                }


            }

            // para card 06

            if (selectedTipoGenericaCard06 != undefined) {

                let newselectedTipoGenericaCard06 = { ...selectedTipoGenericaCard06 }

                let operaciontgRefCard06 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};

                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard03.operaciones.length; i++) {
                    operaciontgRefCard06 = selectedTipoGenericaCard03.operaciones[i];
                    if (operaciontgRefCard06.seccion === _CARD_06 && selectedTipoGenericaCard03.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard03.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard03.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard06.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard06.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard06.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard06(undefined);
                    setSelectedTipoGenericaCard06(newselectedTipoGenericaCard06);
                    //console.log("newselectedTipoGenericaCard06, ", newselectedTipoGenericaCard06);

                }


            }

            // para card 07

            if (selectedTipoGenericaCard07 != undefined) {

                let newselectedTipoGenericaCard07 = { ...selectedTipoGenericaCard07 }

                let operaciontgRefCard07 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard03.operaciones.length; i++) {
                    operaciontgRefCard07 = selectedTipoGenericaCard03.operaciones[i];
                    if (operaciontgRefCard07.seccion === _CARD_07 && selectedTipoGenericaCard03.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard03.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard03.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard07.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard07.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard07.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard07(undefined);
                    setSelectedTipoGenericaCard07(newselectedTipoGenericaCard07);
                    //console.log("newselectedTipoGenericaCard07, ", newselectedTipoGenericaCard07);

                }


            }

            // para card 08

            if (selectedTipoGenericaCard08 != undefined) {

                let newselectedTipoGenericaCard08 = { ...selectedTipoGenericaCard08 }

                let operaciontgRefCard08 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard03.operaciones.length; i++) {
                    operaciontgRefCard08 = selectedTipoGenericaCard03.operaciones[i];
                    if (operaciontgRefCard08.seccion === _CARD_08 && selectedTipoGenericaCard03.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard03.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard03.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard08.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard08.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard08.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard08(undefined);
                    setSelectedTipoGenericaCard08(newselectedTipoGenericaCard08);
                    //console.log("newselectedTipoGenericaCard08, ", newselectedTipoGenericaCard08);

                }


            }

            // para card 09

            if (selectedTipoGenericaCard09 != undefined) {

                let newselectedTipoGenericaCard09 = { ...selectedTipoGenericaCard09 }

                let operaciontgRefCard09 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard09 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard09.seccion === _CARD_09 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard09.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard09.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard09.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard09(undefined);
                    setSelectedTipoGenericaCard09(newselectedTipoGenericaCard09);
                    //console.log("newselectedTipoGenericaCard09, ", newselectedTipoGenericaCard09);

                }

            }

            // para card 10

            if (selectedTipoGenericaCard10 != undefined) {

                let newselectedTipoGenericaCard10 = { ...selectedTipoGenericaCard10 }

                let operaciontgRefCard10 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard10 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard10.seccion === _CARD_10 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard10.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard10.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard10.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard10(undefined);
                    setSelectedTipoGenericaCard10(newselectedTipoGenericaCard10);
                    //console.log("newselectedTipoGenericaCard10, ", newselectedTipoGenericaCard10);

                }

            }


        }

    }

    const onSelectionChangeCard04 = (newVal) => {

        setSelectedItemCard04({ ...newVal });

        let filtroUts = {};
        let variableRestriccionExterna = {};
        let itemOpsCampo = {};

        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 4) {


            // para card 05


            if (selectedTipoGenericaCard05 != undefined) {

                let newselectedTipoGenericaCard05 = { ...selectedTipoGenericaCard05 }

                let operaciontgRefCard05 = {};

                let itemOpsCampo = { ...operaciontgRefCard05 }
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard04.operaciones.length; i++) {
                    operaciontgRefCard05 = selectedTipoGenericaCard04.operaciones[i];
                    if (operaciontgRefCard05.seccion === _CARD_05 && selectedTipoGenericaCard04.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard04.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard04.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard05.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard05.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard05.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard05(undefined);
                    setSelectedTipoGenericaCard05(newselectedTipoGenericaCard05);
                    //console.log("newselectedTipoGenericaCard05, ", newselectedTipoGenericaCard05);

                }


            }

            // para card 06

            if (selectedTipoGenericaCard06 != undefined) {

                let newselectedTipoGenericaCard06 = { ...selectedTipoGenericaCard06 }

                let operaciontgRefCard06 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {}
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard04.operaciones.length; i++) {
                    operaciontgRefCard06 = selectedTipoGenericaCard04.operaciones[i];
                    if (operaciontgRefCard06.seccion === _CARD_06 && selectedTipoGenericaCard04.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard04.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard04.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard06.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard06.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard06.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard06(undefined);
                    setSelectedTipoGenericaCard06(newselectedTipoGenericaCard06);
                    //console.log("newselectedTipoGenericaCard06, ", newselectedTipoGenericaCard06);

                }


            }

            // para card 07

            if (selectedTipoGenericaCard07 != undefined) {

                let newselectedTipoGenericaCard07 = { ...selectedTipoGenericaCard07 }

                let operaciontgRefCard07 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {}
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard04.operaciones.length; i++) {
                    operaciontgRefCard07 = selectedTipoGenericaCard04.operaciones[i];
                    if (operaciontgRefCard07.seccion === _CARD_07 && selectedTipoGenericaCard04.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard04.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard04.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard07.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard07.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard07.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard07(undefined);
                    setSelectedTipoGenericaCard07(newselectedTipoGenericaCard07);
                    //console.log("newselectedTipoGenericaCard07, ", newselectedTipoGenericaCard07);

                }


            }

            // para card 08

            if (selectedTipoGenericaCard08 != undefined) {

                let newselectedTipoGenericaCard08 = { ...selectedTipoGenericaCard08 }

                let operaciontgRefCard08 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {}
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard04.operaciones.length; i++) {
                    operaciontgRefCard08 = selectedTipoGenericaCard04.operaciones[i];
                    if (operaciontgRefCard08.seccion === _CARD_08 && selectedTipoGenericaCard04.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard04.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard04.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard08.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard08.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard08.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard08(undefined);
                    setSelectedTipoGenericaCard08(newselectedTipoGenericaCard08);
                    //console.log("newselectedTipoGenericaCard08, ", newselectedTipoGenericaCard08);

                }


            }

            // para card 09

            if (selectedTipoGenericaCard09 != undefined) {

                let newselectedTipoGenericaCard09 = { ...selectedTipoGenericaCard09 }

                let operaciontgRefCard09 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard09 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard09.seccion === _CARD_09 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard09.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard09.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard09.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard09(undefined);
                    setSelectedTipoGenericaCard09(newselectedTipoGenericaCard09);
                    //console.log("newselectedTipoGenericaCard09, ", newselectedTipoGenericaCard09);

                }

            }

            // para card 10

            if (selectedTipoGenericaCard10 != undefined) {

                let newselectedTipoGenericaCard10 = { ...selectedTipoGenericaCard10 }

                let operaciontgRefCard10 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard10 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard10.seccion === _CARD_10 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard10.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard10.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard10.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard10(undefined);
                    setSelectedTipoGenericaCard10(newselectedTipoGenericaCard10);
                    //console.log("newselectedTipoGenericaCard10, ", newselectedTipoGenericaCard10);

                }

            }


        }

    }

    const onSelectionChangeCard05 = (newVal) => {

        setSelectedItemCard05({ ...newVal });

        let filtroUts = {};
        let variableRestriccionExterna = {};
        let itemOpsCampo = {}

        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 5) {


            // para card 06


            if (selectedTipoGenericaCard06 != undefined) {

                let newselectedTipoGenericaCard06 = { ...selectedTipoGenericaCard06 }

                let operaciontgRefCard06 = {};


                let itemOpsCampo = { ...operaciontgRefCard06 }
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard05.operaciones.length; i++) {
                    operaciontgRefCard06 = selectedTipoGenericaCard05.operaciones[i];
                    if (operaciontgRefCard06.seccion === _CARD_06 && selectedTipoGenericaCard05.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard05.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard05.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard06.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard06.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard06.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard06(undefined);
                    setSelectedTipoGenericaCard06(newselectedTipoGenericaCard06);
                    //console.log("newselectedTipoGenericaCard06, ", newselectedTipoGenericaCard06);

                }


            }

            // para card 07

            if (selectedTipoGenericaCard07 != undefined) {

                let newselectedTipoGenericaCard07 = { ...selectedTipoGenericaCard07 }

                let operaciontgRefCard07 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {}
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard05.operaciones.length; i++) {
                    operaciontgRefCard07 = selectedTipoGenericaCard05.operaciones[i];
                    if (operaciontgRefCard07.seccion === _CARD_07 && selectedTipoGenericaCard05.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard05.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard05.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard07.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard07.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard07.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard07(undefined);
                    setSelectedTipoGenericaCard07(newselectedTipoGenericaCard07);
                    //console.log("newselectedTipoGenericaCard07, ", newselectedTipoGenericaCard07);

                }


            }

            // para card 08

            if (selectedTipoGenericaCard08 != undefined) {

                let newselectedTipoGenericaCard08 = { ...selectedTipoGenericaCard08 }

                let operaciontgRefCard08 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {}
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard05.operaciones.length; i++) {
                    operaciontgRefCard08 = selectedTipoGenericaCard05.operaciones[i];
                    if (operaciontgRefCard08.seccion === _CARD_08 && selectedTipoGenericaCard05.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard05.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard05.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard08.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard08.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard08.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard08(undefined);
                    setSelectedTipoGenericaCard08(newselectedTipoGenericaCard08);
                    //console.log("newselectedTipoGenericaCard08, ", newselectedTipoGenericaCard08);

                }


            }

            // para card 09

            if (selectedTipoGenericaCard09 != undefined) {

                let newselectedTipoGenericaCard09 = { ...selectedTipoGenericaCard09 }

                let operaciontgRefCard09 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard09 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard09.seccion === _CARD_09 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard09.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard09.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard09.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard09(undefined);
                    setSelectedTipoGenericaCard09(newselectedTipoGenericaCard09);
                    //console.log("newselectedTipoGenericaCard09, ", newselectedTipoGenericaCard09);

                }

            }

            // para card 10

            if (selectedTipoGenericaCard10 != undefined) {

                let newselectedTipoGenericaCard10 = { ...selectedTipoGenericaCard10 }

                let operaciontgRefCard10 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard10 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard10.seccion === _CARD_10 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard10.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard10.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard10.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard10(undefined);
                    setSelectedTipoGenericaCard10(newselectedTipoGenericaCard10);
                    //console.log("newselectedTipoGenericaCard10, ", newselectedTipoGenericaCard10);

                }

            }


        }

    }

    const onSelectionChangeCard06 = (newVal) => {

        setSelectedItemCard06({ ...newVal });

        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 6) {



            // para card 07
            let filtroUts = {};
            let variableRestriccionExterna = {};
            let itemOpsCampo = {}

            if (selectedTipoGenericaCard07 != undefined) {

                let newselectedTipoGenericaCard07 = { ...selectedTipoGenericaCard07 }

                let operaciontgRefCard07 = {};


                let itemOpsCampo = {}
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard06.operaciones.length; i++) {
                    operaciontgRefCard07 = selectedTipoGenericaCard06.operaciones[i];
                    if (operaciontgRefCard07.seccion === _CARD_07 && selectedTipoGenericaCard06.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard06.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard06.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard07.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard07.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard07.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard07(undefined);
                    setSelectedTipoGenericaCard07(newselectedTipoGenericaCard07);
                    //console.log("newselectedTipoGenericaCard07, ", newselectedTipoGenericaCard07);

                }


            }

            // para card 08

            if (selectedTipoGenericaCard08 != undefined) {

                let newselectedTipoGenericaCard08 = { ...selectedTipoGenericaCard08 }

                let operaciontgRefCard08 = {};

                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {}
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard06.operaciones.length; i++) {
                    operaciontgRefCard08 = selectedTipoGenericaCard06.operaciones[i];
                    if (operaciontgRefCard08.seccion === _CARD_08 && selectedTipoGenericaCard06.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard06.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard06.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard08.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard08.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard08.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard08(undefined);
                    setSelectedTipoGenericaCard08(newselectedTipoGenericaCard08);
                    //console.log("newselectedTipoGenericaCard08, ", newselectedTipoGenericaCard08);

                }


            }

            // para card 09

            if (selectedTipoGenericaCard09 != undefined) {

                let newselectedTipoGenericaCard09 = { ...selectedTipoGenericaCard09 }

                let operaciontgRefCard09 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard09 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard09.seccion === _CARD_09 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard09.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard09.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard09.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard09(undefined);
                    setSelectedTipoGenericaCard09(newselectedTipoGenericaCard09);
                    //console.log("newselectedTipoGenericaCard09, ", newselectedTipoGenericaCard09);

                }

            }

            // para card 10

            if (selectedTipoGenericaCard10 != undefined) {

                let newselectedTipoGenericaCard10 = { ...selectedTipoGenericaCard10 }

                let operaciontgRefCard10 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard10 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard10.seccion === _CARD_10 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard10.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard10.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard10.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard10(undefined);
                    setSelectedTipoGenericaCard10(newselectedTipoGenericaCard10);
                    //console.log("newselectedTipoGenericaCard10, ", newselectedTipoGenericaCard10);

                }

            }


        }

    }

    const onSelectionChangeCard07 = (newVal) => {

        setSelectedItemCard07({ ...newVal });

        let filtroUts = {};
        let variableRestriccionExterna = {};
        let itemOpsCampo = {}

        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 7) {


            // para card 08

            if (selectedTipoGenericaCard08 != undefined) {

                let newselectedTipoGenericaCard08 = { ...selectedTipoGenericaCard08 }

                let operaciontgRefCard08 = {};

                let itemOpsCampo = { ...operaciontgRefCard08 }
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenericaCard07.operaciones.length; i++) {
                    operaciontgRefCard08 = selectedTipoGenericaCard07.operaciones[i];
                    if (operaciontgRefCard08.seccion === _CARD_08 && selectedTipoGenericaCard07.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenericaCard07.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenericaCard07.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard08.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : '';
                            if (itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                            }
                        }
                    }

                    newselectedTipoGenericaCard08.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard08.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard08(undefined);
                    setSelectedTipoGenericaCard08(newselectedTipoGenericaCard08);
                    //console.log("newselectedTipoGenericaCard08, ", newselectedTipoGenericaCard08);

                }


            }

            // para card 09

            if (selectedTipoGenericaCard09 != undefined) {

                let newselectedTipoGenericaCard09 = { ...selectedTipoGenericaCard09 }

                let operaciontgRefCard09 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard09 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard09.seccion === _CARD_09 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard09.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard09.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard09.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard09(undefined);
                    setSelectedTipoGenericaCard09(newselectedTipoGenericaCard09);
                    //console.log("newselectedTipoGenericaCard09, ", newselectedTipoGenericaCard09);

                }

            }

            // para card 10

            if (selectedTipoGenericaCard10 != undefined) {

                let newselectedTipoGenericaCard10 = { ...selectedTipoGenericaCard10 }

                let operaciontgRefCard10 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard10 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard10.seccion === _CARD_10 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard10.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard10.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard10.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard10(undefined);
                    setSelectedTipoGenericaCard10(newselectedTipoGenericaCard10);
                    //console.log("newselectedTipoGenericaCard10, ", newselectedTipoGenericaCard10);

                }

            }


        }

    }

    const onSelectionChangeCard08 = (newVal) => {

        setSelectedItemCard08({ ...newVal });

        let filtroUts = {};
        let variableRestriccionExterna = {};
        let itemOpsCampo = {}

        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 8) {


            // para card 09

            if (selectedTipoGenericaCard09 != undefined) {

                let newselectedTipoGenericaCard09 = { ...selectedTipoGenericaCard09 }

                let operaciontgRefCard09 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard09 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard09.seccion === _CARD_09 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard09.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard09.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard09.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard09(undefined);
                    setSelectedTipoGenericaCard09(newselectedTipoGenericaCard09);
                    //console.log("newselectedTipoGenericaCard09, ", newselectedTipoGenericaCard09);

                }

            }

            // para card 10

            if (selectedTipoGenericaCard10 != undefined) {

                let newselectedTipoGenericaCard10 = { ...selectedTipoGenericaCard10 }

                let operaciontgRefCard10 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard10 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard10.seccion === _CARD_10 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard10.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard10.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard10.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard10(undefined);
                    setSelectedTipoGenericaCard10(newselectedTipoGenericaCard10);
                    //console.log("newselectedTipoGenericaCard10, ", newselectedTipoGenericaCard10);

                }

            }


        }

    }

    const onSelectionChangeCard09 = (newVal) => {

        setSelectedItemCard09({ ...newVal });

        let filtroUts = {};
        let variableRestriccionExterna = {};
        let itemOpsCampo = {}

        if (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard > 9) {



            // para card 10

            if (selectedTipoGenericaCard10 != undefined) {

                let newselectedTipoGenericaCard10 = { ...selectedTipoGenericaCard10 }

                let operaciontgRefCard10 = {};
                filtroUts = {};
                variableRestriccionExterna = {};
                itemOpsCampo = {};
                let encontrado = false;

                for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                    operaciontgRefCard10 = selectedTipoGenerica.operaciones[i];
                    if (operaciontgRefCard10.seccion === _CARD_10 && selectedTipoGenerica.operaciones[i].tipoOperacion === _TIPO_OPERACION_VIEW) {
                        encontrado = true;
                        break;
                    }
                }

                if (encontrado) {

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === operaciontgRefCard10.id) {
                            filtroUts[itemOpsCampo.campotgRef] = newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campotg] : "";
                            variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = { valor: newVal !== null && newVal !== undefined ? newVal.uts[itemOpsCampo.campoValueTg] : "" };
                        }
                    }

                    newselectedTipoGenericaCard10.filtroUts = { ...filtroUts };
                    newselectedTipoGenericaCard10.variableRestriccionExterna = { ...variableRestriccionExterna };

                    setSelectedItemCard10(undefined);
                    setSelectedTipoGenericaCard10(newselectedTipoGenericaCard10);
                    //console.log("newselectedTipoGenericaCard10, ", newselectedTipoGenericaCard10);

                }

            }


        }

    }

    const onSelectionChangeCard10 = (newVal) => {

        setSelectedItemCard10({ ...newVal });

    }

    const onClickAsignarItemPendiente = async (evento) => {

        let operaciontgRefCard02 = {};

        let itemOpsCampo = { ...operaciontgRefCard02 }

        for (let i = 0; i < selectedTipoGenericaCard02.operaciones.length; i++) {
            operaciontgRefCard02 = selectedTipoGenericaCard02.operaciones[i];
            if (operaciontgRefCard02.seccion === _CARD_02 && operaciontgRefCard02.tipoOperacion === _TIPO_OPERACION_ASSING)
                break;
        }

        let genericaAAsignar = { uts: {} };
        genericaAAsignar["tg"] = operaciontgRefCard02.tgRef;
        genericaAAsignar["idEmpresa"] = selectedTipoGenericaCard02.idEmpresa;
        genericaAAsignar["id"] = 0;


        for (let i = 0; i < selectedTipoGenericaCard02.operacionesCampos.length; i++) {
            itemOpsCampo = selectedTipoGenericaCard02.operacionesCampos[i];
            if (itemOpsCampo.id === operaciontgRefCard02.id) {
                genericaAAsignar.uts[itemOpsCampo.campotgRef] = selectedItemCard02.uts[itemOpsCampo.campotg];
            }
        }

        /*console.log("selectedTipoGenericaCard02.operacionesCampos, ",selectedTipoGenericaCard02.operacionesCampos);
        console.log("selectedTipoGenericaCard02",selectedTipoGenericaCard02);
        console.log("operaciontgRefCard02",operaciontgRefCard02);
        console.log("genericaAAsignar",genericaAAsignar);        */

        console.log("genericaAAsignar, ", genericaAAsignar);

        await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaAAsignar).then(response => {

            console.log("response, ", response);
            if (response.mensaje === "") {

                setSelectedItemCard02(undefined);

                setSelectedTipoGenericaCard02({ ...selectedTipoGenericaCard02, version: selectedTipoGenericaCard02.version + 1 });
                setSelectedTipoGenericaCard03({ ...selectedTipoGenericaCard03, version: selectedTipoGenericaCard03.version + 1 });

                if (selectedTipoGenericaCard04 != undefined)
                    setSelectedTipoGenericaCard04({ ...selectedTipoGenericaCard04, version: selectedTipoGenericaCard04.version + 1 });

                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Dato asignado', life: 3000 });
            }
            else {
                toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
            }

        });

        //newselectedTipoGenericaCard03.filtroUts = { ...filtroUts };
        //newselectedTipoGenericaCard03.variableRestriccionExterna = { ...variableRestriccionExterna };


    }

    const onClickEliminarItemAsignado = async (evento) => {

        let operaciontgRefCard03 = {};

        let itemOpsCampo = { ...operaciontgRefCard03 }

        for (let i = 0; i < selectedTipoGenericaCard03.operaciones.length; i++) {
            operaciontgRefCard03 = selectedTipoGenericaCard03.operaciones[i];
            if (operaciontgRefCard03.seccion === _CARD_03 && operaciontgRefCard03.seccion === _TIPO_OPERACION_QUITAR_ASIG)
                break;
        }

        let genericaAEliminar = { uts: {} };
        genericaAEliminar["tg"] = operaciontgRefCard03.tgRef;
        genericaAEliminar["idEmpresa"] = selectedItemCard03.idEmpresa;
        genericaAEliminar["id"] = selectedItemCard03.id;


        for (let i = 0; i < selectedTipoGenericaCard03.operacionesCampos.length; i++) {
            itemOpsCampo = selectedTipoGenericaCard03.operacionesCampos[i];
            if (itemOpsCampo.id === operaciontgRefCard03.id) {
                genericaAEliminar.uts[itemOpsCampo.campotgRef] = selectedItemCard03.uts[itemOpsCampo.campotg];
            }
        }
        await genericaSistemaService.RemoveGenericaSistema(idEmpresa, idioma, userName, genericaAEliminar).then(response => {

            console.log("response, ", response);
            if (response.mensaje === "") {

                setSelectedItemCard03(undefined);

                setSelectedTipoGenericaCard02({ ...selectedTipoGenericaCard02, version: selectedTipoGenericaCard02.version + 1 });
                setSelectedTipoGenericaCard03({ ...selectedTipoGenericaCard03, version: selectedTipoGenericaCard03.version + 1 });

                if (selectedTipoGenericaCard04 != undefined)
                    setSelectedTipoGenericaCard04({ ...selectedTipoGenericaCard04, version: selectedTipoGenericaCard04.version + 1 });

                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Dato elminado', life: 3000 });
            }
            else {
                toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
            }

        });


        //newselectedTipoGenericaCard03.filtroUts = { ...filtroUts };
        //newselectedTipoGenericaCard03.variableRestriccionExterna = { ...variableRestriccionExterna };


    }

    const tieneOpeacionesPendAsig = () => {
        return selectedTipoGenericaCard02 !== undefined && selectedTipoGenericaCard03 !== undefined
            && selectedTipoGenericaCard02.operaciones.length > 0
            && selectedTipoGenericaCard02.operaciones.some(x => x.tipoOperacion === _TIPO_OPERACION_ASSING)
            && selectedTipoGenericaCard03.operaciones.length > 0
            && selectedTipoGenericaCard03.operaciones.some(x => x.tipoOperacion === _TIPO_OPERACION_QUITAR_ASIG)

    }

    const seccionButtonPendAsig = () => {
        if (tieneOpeacionesPendAsig()) {
            return (<div className="col-12 md:col-12 lg:col-12">

                <div className="col" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                    <Button className='my-auto mx-3' aria-label="Agregar" tooltip="Agregar" icon="pi pi-arrow-down"
                        onClick={onClickAsignarItemPendiente} disabled={selectedItemCard02 === undefined} />
                    <Button className='my-auto mx-3' aria-label="Eliminar" tooltip="Eliminar" icon="pi pi-arrow-up"
                        onClick={onClickEliminarItemAsignado} disabled={selectedItemCard03 === undefined} />

                </div>

            </div>);
        }
        else {
            return (<></>);
        }

    }

    const arrayTemplate = [{}, {}, {}, {}, {}, {}];
    const bodyTemplate = () => {
        return <Skeleton></Skeleton>
    }

    const seccionCardTop = () => {

        if (selectedTipoGenerica === undefined) {
            return (<div className="card col-12 md:col-12 lg:col-12">
                <DataTable value={arrayTemplate} className="p-datatable-striped" header={bodyTemplate}>
                    <Column field="code" header="Code" style={{ width: '25%' }} body={bodyTemplate}></Column>
                    <Column field="name" header="Name" style={{ width: '25%' }} body={bodyTemplate}></Column>
                </DataTable>
            </div>);
        }
        else {
            return (<div className="card col-12">
                <DataTableGenerica name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardTop}
                    label={props.label} selectedTipoGenerica={selectedTipoGenerica}
                    addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />

            </div>);
        }
    }

    const skeletonTemplate = (<div className="card col-12 md:col-12 lg:col-12">
        <DataTable value={arrayTemplate} className="p-datatable-striped" header={bodyTemplate}>
            <Column field="code" header="Code" style={{ width: '25%' }} body={bodyTemplate}></Column>
            <Column field="name" header="Name" style={{ width: '25%' }} body={bodyTemplate}></Column>
        </DataTable>
    </div>)

    const seccionTemplate = (ordenCard, _selectedTipoGenericaRef, onSelectionChangeCardRef) => {
        let selectedTipoGenericaRef = { ..._selectedTipoGenericaRef };

        //console.log(selectedTipoGenerica.tipoOrganizacionContenido, OrdenCard, selectedTipoGenericaRef, onSelectionChangeCardRef);
        if (ordenCard === 1 || (selectedTipoGenerica.tipoOrganizacionContenido === "CONFIG_SEVERAL_CARD" && selectedTipoGenerica.cantidadCard >= ordenCard)) {

            if (ordenCard === 1 && (selectedTipoGenerica.operaciones === undefined || selectedTipoGenerica.operaciones.length === 0)) {
                selectedTipoGenericaRef = undefined;
            }

            if (selectedTipoGenericaRef === undefined) {
                return skeletonTemplate;
            }
            else {

                if (selectedTipoGenericaRef.tipoOrganizacionContenido === "INFORME_PROGRESS_BAR") {

                    return (<div className="card col-12 md:col-12 lg:col-12">
                        <Reporte2 name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                            label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                            addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />
                    </div >

                    );
                }

                if (selectedTipoGenericaRef.tipoOrganizacionContenido === "INFORME_GRAFICOS") {

                    return (<div className="card col-12 md:col-12 lg:col-12">
                        <ReporteGraficos name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                            label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                            addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />
                    </div >

                    );
                }

                else if (selectedTipoGenericaRef.tipoOrganizacionContenido === "INFORME_POWERBI") {

                    return (<div className="card col-12 md:col-12 lg:col-12">
                        <ReportePowerBi name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                            label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                            addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />
                    </div>

                    );
                }

                else if (selectedTipoGenericaRef.tipoOrganizacionContenido === "DYNAMIC_QR") {

                    return (<div className="card col-12 md:col-12 lg:col-12">
                        <DynamicQR name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                            label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                            addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />
                    </div>

                    );
                }


                else if (selectedTipoGenericaRef.tipoOrganizacionContenido === "REPORT") {

                    return (<div className="card col-12 md:col-12 lg:col-12">
                        <Reporte name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                            label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                            addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />
                    </div>

                    );
                }

                else if (selectedTipoGenericaRef.tipoOrganizacionContenido === "DISEÑADOR_FORMATO") {
                    console.log("DISEÑADOR_FORMATO", selectedTipoGenericaRef);

                    return (<div className="card col-12 md:col-12 lg:col-12">
                        <DiseñadorFormulario name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                            label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                            addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />
                    </div>);


                }

                // step
                else if (selectedTipoGenericaRef.tipoOrganizacionContenido === "FORMULARIO_STEPS") {

                    return (<div className="card col-12 md:col-12 lg:col-12">

                        <FormularioStep name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                            label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                            addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu}
                            genericaSistemaDialog={true}
                            etiquetasModulo={[{ 'hola': 'hola' }]}
                        />

                    </div>

                    );
                }

                else {
                    //Default

                    return (<div className="card col-12 md:col-12 lg:col-12">
                        <DataTableGenerica name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                            label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                            addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />
                    </div>);

                }

            }
        }
        else
            return (<></>);

    }

    //console.log("selectedTipoGenericaCard02, ", selectedTipoGenericaCard02, "selectedTipoGenericaCard03, ",selectedTipoGenericaCard03)
    // Para el render
    if (selectedTipoGenerica !== undefined) {


        switch (selectedTipoGenerica.tipoOrganizacionContenido) {
            //ONE_CARD

            case "REPORT": return (  // ONE_CARD

                <Reporte name={props.name} level={props.level} codMenu={props.codMenu}
                    label={props.label} selectedTipoGenerica={selectedTipoGenerica}
                    addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />
            );
                break;

            case "eee": return (  // ONE_CARD
                <>
                    <Toast ref={toast} />
                    <div className="card">
                        <DataTableGenerica name={props.name} level={props.level} codMenu={props.codMenu}
                            label={props.label} selectedTipoGenerica={selectedTipoGenerica}
                            addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu} />

                    </div>
                </>);
                break;

            default:

                //console.log("selectedTipoGenericaCard02", selectedTipoGenericaCard02, "selectedTipoGenericaCard03, ", selectedTipoGenericaCard03);

                return (<>
                    <Toast ref={toast} />

                    <div className='grid' style={{ padding: 0, margin: 0 }}>

                        {seccionTemplate(1, selectedTipoGenerica, onSelectionChangeCardTop)}

                        {seccionTemplate(2, selectedTipoGenericaCard02, onSelectionChangeCard02)}
                        {seccionButtonPendAsig()}

                        {seccionTemplate(3, selectedTipoGenericaCard03, onSelectionChangeCard03)}

                        {seccionTemplate(4, selectedTipoGenericaCard04, onSelectionChangeCard04)}

                        {seccionTemplate(5, selectedTipoGenericaCard05, onSelectionChangeCard05)}

                        {seccionTemplate(6, selectedTipoGenericaCard06, onSelectionChangeCard06)}

                        {seccionTemplate(7, selectedTipoGenericaCard07, onSelectionChangeCard07)}

                        {seccionTemplate(8, selectedTipoGenericaCard08, onSelectionChangeCard08)}

                        {seccionTemplate(9, selectedTipoGenericaCard09, onSelectionChangeCard09)}

                        {seccionTemplate(10, selectedTipoGenericaCard10, onSelectionChangeCard10)}

                    </div>

                </>);



                break;


        }
    }
    else
        return (<></>);


};

export default ContentCardOrganizator;